import {get, post} from "./axiosInstance";

export const apiRequestMemberLogin = (data: {username: string, password: string}) => {
  // return get("/mockData/login.json")
  return post("/member/login", data)
}

export const apiRequestGetMemberInfo = () => {
  // return get("/mockData/files.json")
  return get("/member/info")
}

export const apiRequestLibrary = (currentPage: number, postsPerPage: number) => {
  // return get("/mockData/eLibrary.json")
  return get(`/member/library?page=${currentPage + 1}&limit=${postsPerPage}`) // plus 1 here because it starts from 1
}

export const apiRequestDownloads = (currentPage: number, postsPerPage: number) => {
  // return get("/mockData/downloads.json")
  return get(`/member/downloads?page=${currentPage + 1}&limit=${postsPerPage}`) // plus 1 here because it starts from 1
}

export const apiRequestPostMemberForm = (formData: FormData) => {
  return post("/member/message", formData, true)
}

export const apiRequestScheduleMeeting = (data: {specialistName: string, meetingDate: string, meetingTime: string}) => {
  return post("/member/schedule-meeting", data)
}

export const apiRequestGetMeetings = () => {
  return get("/member/meetings")
}

export const apiRequestUnsubscribe = (email: string) => {
  return post("/unsubscribe", {email})
}

export const apiRequestDeactivateAccount = () => {
  return post("/member/account/deactivate", {})
}

export const apiRequestGetQuizzes = () => {
  return get(`/member/quizzes`)
}

export const apiRequestGetQuiz = (id: number) => {
  return get(`/member/quiz/${id}`)
}